module.exports = __webpack_public_path__ + "static/media/Elf3.2f605ba1.png";